import { render, staticRenderFns } from "./FooterBrandLayout.vue?vue&type=template&id=e859d620&"
import script from "./FooterBrandLayout.vue?vue&type=script&lang=js&"
export * from "./FooterBrandLayout.vue?vue&type=script&lang=js&"
import style0 from "./FooterBrandLayout.vue?vue&type=style&index=0&id=e859d620&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports